import React from 'react';
import Background from "../../../assets/images/background/banner.jpg";
import "./logistic.css"
import { Link } from 'react-router-dom';

import Logisticimg from "../../../assets/images/Industry Page/logistics.jpg";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import Faq from "./faq-logistic";
import Swiper from "../Bfsi Solution/swiper";
import SEO from "../../seo";

export default function Logistic() {
    const pageKeywords = [
        "react website",
        "static pages",
        "web development",
        "SEO services"
    ]; 
      const CounterOnScroll = ({ end, duration = 2, className }) => {
        const { ref, inView } = useInView({
            triggerOnce: true,
            threshold: 0.3,
        });

        return (
            <span ref={ref}>
                {inView ? (
                    <CountUp end={end} duration={duration} className={className} />
                ) : (
                    <span className={className}>0</span>
                )}
            </span>
        );
    };
    return (
        <div className='product-brand'>
                <SEO
                title="Logistics"
                description="Industries Take Advantage of Shipping &#038; Logistics Software Development We provide world-class logistics management software to optimize your logistics process Order and Shipment Tracking Details: Implement real-time tracking capabilities for orders and shipments, allowing users to monitor the status and location of their shipments. Benefits: Improved transparency, enhanced customer satisfaction, and efficient logistics management. Route [&hellip;]"
                canonical="https://www.hwplindia.com/industries/logistics/"
                ogImage="https://www.hwplindia.com/wp-content/uploads/2023/12/industries-logistics-img.jpg"
                keywords={pageKeywords}
            />
            <section
                className="page-title"
                style={{ backgroundImage: `url(${Background})` }}
            >
                <div className="auto-container">
                    <h2>Logistics</h2>
                    <ul className="bread-crumb clearfix">
                        <li>
                            <Link to="/">Home</Link>
                        </li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li><Link to='/industries'>Industries</Link></li>
                        
                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li>Logistics</li>
                    </ul>
                </div>
            </section>
             <section className='bfsi'>
                <section className="ai-ml-main">
                    <div className='ai-ml-container'>
                        {/* Content Section */}
                        <div className="branding-content">
                            {/* CTA */}
                            <section className="cta-section">
                                <span className='tech'>Industries</span>
                                <h3 className='tech-h3'>Take Advantage of Shipping & Logistics Software Development</h3>
                                <p className='email'>
                                   We provide world-class logistics management software to optimize your logistics process
                                </p>
                            </section>

                            <section className="Industri-section">
                                <div className="industri-card">
                                    <h3 className="indu-title">Order and Shipment Tracking</h3>
                                    <p>
                                        <strong>Details:</strong> Implement real-time tracking capabilities for orders and shipments, allowing users to monitor the status and location of their shipments.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong>  Improved transparency, enhanced customer satisfaction, and efficient logistics management.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Route Optimization and Planning</h3>
                                    <p>
                                        <strong>Details:</strong> Integrate route optimization algorithms to plan and optimize delivery routes, reducing fuel costs and improving delivery efficiency.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Cost savings, reduced delivery times, and enhanced overall fleet efficiency.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Warehouse Management System (WMS)</h3>
                                    <p>
                                        <strong>Details:</strong> Develop a WMS to streamline warehouse operations, including inventory management, order picking, and warehouse organization.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Improved inventory accuracy, reduced errors, and optimized warehouse processes.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Fleet Management</h3>
                                    <p>
                                        <strong>Details:</strong> Include features for managing and monitoring the entire fleet, including vehicle tracking, maintenance schedules, and driver performance.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Enhanced fleet visibility, reduced maintenance costs, and improved overall fleet efficiency.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Inventory Visibility</h3>
                                    <p>
                                        <strong>Details:</strong> Provide real-time visibility into inventory levels, allowing businesses to manage stock levels, prevent stockouts, and optimize storage.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Improved inventory management, reduced carrying costs, and increased order fulfillment accuracy.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Automated Order Processing</h3>
                                    <p>
                                        <strong>Details:</strong> Implement automation for order processing, including order validation, labeling, and documentation generation.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Increased order accuracy, reduced processing time, and improved overall order fulfillment.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Supplier Collaboration Tools</h3>
                                    <p>
                                        <strong>Details:</strong> Develop tools to facilitate collaboration with suppliers, enabling real-time communication, order updates, and inventory synchronization.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Improved supplier relationships, enhanced supply chain visibility, and streamlined communication
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Customs and Compliance Management</h3>
                                    <p>
                                        <strong>Details:</strong> Include features for managing customs documentation, compliance checks, and regulatory requirements for international shipments.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Reduced risk of compliance issues, faster customs clearance, and smoother international shipping.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Real-time Alerts and Notifications</h3>
                                    <p>
                                        <strong>Details:</strong> Provide alerts and notifications for various events, such as delivery updates, delays, and exceptions in the shipping process.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong>  Enhanced customer communication, proactive issue resolution, and improved customer satisfaction.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Integration with E-commerce Platforms</h3>
                                    <p>
                                        <strong>Details:</strong> Ensure seamless integration with e-commerce platforms for automatic order processing, inventory updates, and shipping information synchronization.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong>  Streamlined e-commerce operations, improved order accuracy, and enhanced customer experience.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Customer Portal</h3>
                                    <p>
                                        <strong>Details:</strong>  Create a customer portal for self-service, allowing customers to track orders, view delivery schedules, and manage shipments.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Improved customer engagement, reduced customer inquiries, and enhanced user experience.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Data Analytics and Reporting</h3>
                                    <p>
                                        <strong>Details:</strong> Implement analytics tools to track and analyze key performance indicators (KPIs) such as delivery times, order accuracy, and inventory turnover.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Informed decision-making, performance optimization, and continuous improvement.
                                    </p>
                                </div>

                                 <div className="industri-card">
                                    <h3 className="indu-title">Mobile App for Drivers and Field Operations</h3>
                                    <p>
                                        <strong>Details:</strong> Develop a mobile app for drivers and field personnel to receive assignments, update delivery status, and access real-time information.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Increased mobility, improved communication, and enhanced operational efficiency.
                                    </p>
                                </div>

                                 <div className="industri-card">
                                    <h3 className="indu-title">Environmental Sustainability Features</h3>
                                    <p>
                                        <strong>Details:</strong> Integrate features to monitor and optimize fuel consumption, reduce carbon emissions, and implement eco-friendly logistics practices.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Environmental responsibility, cost savings through efficient practices, and improved corporate sustainability.
                                    </p>
                                </div>
                            </section>
                        </div>
                    </div>
                    <section className='bfsi-clor'>
                        <section class="bfsi-section">
                            <div class="bfsi-grid">
                                <div class="bfsi-left">
                                    <h2>
                                        Meet Best Shipping & Logistics  Software Development Company
                                    </h2>

                                    <p>
                                        At Horizon Webinfo Pvt. Ltd. we specialize in crafting cutting-edge logistics solutions that cater to a diverse range of industries. Our innovative web and application development services are tailored to streamline operations, optimize efficiency, and transform the way businesses manage their logistics.
                                    </p>

                                    <div class="bfsi-stats">
                                        <div className="stat-box">
                                            <h3>
                                                <CounterOnScroll end={20} duration={2} className="counter" /> +
                                            </h3>
                                            <span>Years Of Experience</span>
                                        </div>

                                        <div className="stat-box">
                                            <h3>
                                                <CounterOnScroll end={5000} duration={3} className="counter" /> +
                                            </h3>
                                            <span>Happy Customers</span>
                                        </div>

                                    </div>
                                    <span className='elementor-divider-separator'></span>
                                </div>

                                <div class="bfsi-right">
                                    <div class="red-shape"></div>
                                    <img src={Logisticimg} class="bfsi-img" />
                                </div>
                            </div>
                        </section>
                    </section>

                    <Faq />
                    <Swiper />

                </section>
            </section>
        </div>
    );
}